import { IInsideMultiBetArea } from '../interfaces';
import { RouletteDefinition } from './RouletteDefinition';

export class AmericanRouletteDefinition {
    private static insideBetsOrder = [
        0, 28, 9, 26, 30, 11, 7, 20, 32, 17, 5, 22, 34, 15, 3, 24, 36, 13, 1, 37, 27, 10, 25, 29,
        12, 8, 19, 31, 18, 6, 21, 33, 16, 4, 23, 35, 14, 2,
    ];

    public static insideBets = RouletteDefinition.generateInsideBets(
        AmericanRouletteDefinition.insideBetsOrder,
    );

    public static insideBetsMap = RouletteDefinition.generateInsideBetsMap(
        AmericanRouletteDefinition.insideBets,
    );

    public static START_SIDE_SECTORS_AMERICAN = AmericanRouletteDefinition.insideBets.slice(22, 35); // [25, 29, 12, 8, 19, 31, 18, 6, 21, 33, 16, 4, 23]

    public static END_SIDE_SECTORS_AMERICAN = AmericanRouletteDefinition.insideBets
        .slice(3, 16)
        .reverse(); // [24, 3, 15, 34, 22, 5, 17, 32, 20, 7, 11, 30, 26]

    public static START_CORNER_SECTORS_AMERICAN = AmericanRouletteDefinition.insideBets.slice(
        16,
        22,
    ); // [36, 13, 1, 37, 27, 10]

    public static END_CORNER_SECTORS_AMERICAN = [
        ...AmericanRouletteDefinition.insideBets.slice(35, 38),
        ...AmericanRouletteDefinition.insideBets.slice(0, 3),
    ]; // [35, 14, 2, 0, 28, 9]

    public static insideMultiBetsMap = AmericanRouletteDefinition.insideBets.reduce<
        Record<number, Partial<Record<IInsideMultiBetArea, number[]>>>
    >((finalValue, sector) => {
        const { value } = sector;

        if (RouletteDefinition.isZeroSector(value)) {
            return finalValue;
        }

        if (value === 2) {
            // split bet with 00
            finalValue[value].splitDoubleZero = [37, value];
            // square bet with 00 and 0
            finalValue[value].squareZeroes = [0, 37, value];
            // split bet with 0
            finalValue[value].splitZero = [0, value];
            // square bet with 0
            finalValue[value].squareZero = [0, 1, value];
            // top zeroes
            finalValue[value].topZeroes = [0, 37];
            return finalValue;
        }

        if (value === 1) {
            // split bet with 0
            finalValue[value].splitZero = [0, value];
            // basket bet for 0, 00, 1, 2, 3
            finalValue[value].five = [0, 37, 1, 2, 3];

            return finalValue;
        }

        if (value === 3) {
            // split bet with 00
            finalValue[value].splitZero = [37, value];
            // square bet with 00
            finalValue[value].squareZero = [37, value - 1, value];
            return finalValue;
        }

        return finalValue;
    }, RouletteDefinition.generateCommonInsideMultiBetsMap(AmericanRouletteDefinition.insideBets));
}
